/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import { slug } from '../../../common';

// Make translation calls shorter
const t = (...args) => app.translator.trans(...args);
const prfx = `${slug}.forum.achievement`;

export default class UnlockedBy extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const { achievementLevel } = this.attrs;

		const userCount = achievementLevel.userCount();

		return [<span className="UnlockedBy-label">{t(`${prfx}.unlocked_by`)}</span>, <span className="UnlockedBy-userCount">{userCount}</span>];
	}
}
